import { ReactNode } from "react";
import { SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
import { AdminTopNav } from "./AdminTopNav";
import { RoleBasedSidebar } from "./RoleBasedSidebar";

interface AdminLayoutProps {
  children: ReactNode;
  userEmail?: string;
  pendingCount: number;
  packageCounts: {
    pendingReview: number;
    awaitingPickupConfirmation: number;
    pickupScheduled: number;
    pickedUp: number;
    delivered: number;
  };
}

export const AdminLayout = ({
  children,
  userEmail,
  pendingCount,
  packageCounts,
}: AdminLayoutProps) => {
  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full bg-muted/30">
        <RoleBasedSidebar packageCounts={packageCounts} />
        
        <div className="flex-1 flex flex-col">
          {/* Top Navigation with Sidebar Trigger */}
          <header className="h-16 border-b bg-card flex items-center justify-between px-4 sticky top-0 z-50">
            <div className="flex items-center gap-4">
              <SidebarTrigger />
              <AdminTopNav pendingCount={pendingCount} userEmail={userEmail} />
            </div>
          </header>

          {/* Main Content */}
          <main className="flex-1 p-6">
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};
